import RevisableLanguagePack from "../../../../../lib/html5-software-library/src/ranj/language/RevisableLanguagePack";
import LayoutManager from "../../../../../lib/html5-software-library/src/ranj/layout/LayoutManager";
import GameEvent from "../../../core/application/GameEvent";
import AbstractMediator from "../../../core/ui/AbstractMediator";
import ClickEaterFactory from "../../../core/ui/ClickEaterFactory";
import TimerEvent from "../event/TimerEvent";

export default class TimerMediator extends AbstractMediator {
    /**
     * @constructor
     * @param {createjs.MovieClip} target 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {ClickEaterFactory} clickEaterFactory 
     * @param {LayoutManager} layoutManager 
     * @param {RevisableLanguagePack} languagePack 
     */
    constructor(target, dispatcher, clickEaterFactory, layoutManager, languagePack, timerConfig) {
        super(target, dispatcher, clickEaterFactory, layoutManager);
        this._languagePack = languagePack;
        this._timerConfig = timerConfig;
    }

    initialize() {
        super.initialize();



        // Timer configs
        // calculating seconds into ms (should be via a method?)
        this._reminderInterval = this._timerConfig.getValue("reminderInterval") * 1000;
        this._reminderLasting = this._timerConfig.getValue("reminderLasting") * 1000;
        this._timerValue = this._timerConfig.getValue("timerValue") * 1000;


        // Events
        this.registerEventListener(TimerEvent.START_TIMER, this.start.bind(this));
        this.registerEventListener(TimerEvent.PAUSE_TIMER, this.pause.bind(this));
        this.registerEventListener(GameEvent.TIME_CHANGE, this._handleTicking.bind(this));

        // Texts for timers
        // reminder label will need to prepend with the amount of minutes left and a space
        this._reminderText = this._languagePack.getText(`hub.timer.reminderLabel`);
        this._timeOutText = this._languagePack.getText(`hub.timer.timeOutLabel`);

        this._tweenTarget = createjs.Tween.get(this._target);
        this._shownPosition = this._target.y;
        this._hiddenPosition = this._shownPosition - TimerMediator.HIDDEN_Y_OFFSET;

        this._hide();
    }

    reset() {
        // reset timer
    }

    start() {
        this._startTime = null;
        this._started = true;
    }

    pause() {
        // stop ticking
    }

    _handleTicking(data) {
        if (this._started) {
            let currentTime = data.params.data.time;
            if (this._startTime === null) {
                this._startTime = currentTime;
                this._nextIntervalTimeShow = this._startTime;
                this._nextIntervalTimeHide = this._startTime + this._reminderLasting;
                this._endTime = this._startTime + this._timerValue;
            }
            if (currentTime >= this._endTime) {
                // End state
                this.changeText(this._timeOutText, true);
                this._show(0,TimerMediator.ANIMATION_TIME);
                this._started = false;
            } else if (currentTime >= this._nextIntervalTimeHide) {
                // Hide interval
                this._hide(0, TimerMediator.ANIMATION_TIME);
                this._nextIntervalTimeHide = this._nextIntervalTimeShow + this._reminderLasting;
            } else if (currentTime >= this._nextIntervalTimeShow) {
                // Show interval
                let amountOfMinutesLeft = Math.round((this._timerValue - (currentTime - this._startTime)) / 60000);
                this.changeText(amountOfMinutesLeft + " " + this._reminderText);
                this._show(0, TimerMediator.ANIMATION_TIME);
                this._nextIntervalTimeShow = currentTime + this._reminderInterval;
            }
        }
    }

    _hide(wait = 0, delay = 0) {
        this._animateY(wait, delay, this._hiddenPosition);
    }

    _show(wait = 0, delay = 0) {
        this._animateY(wait, delay, this._shownPosition);
    }

    _animateY(wait, delay, newYPosition) {
        createjs.Tween.get(this._target)
            .wait(wait)
            .to({ y: newYPosition }, delay);
    }

    changeText(text = "", urgent = false) {
        this._target.textField.text = text;

        if (urgent) {
            this._target.gotoAndStop(1);
        } else {
            this._target.gotoAndStop(0);
        }
    }

    destroy() {
        super.destroy();
    }
}

TimerMediator.HIDDEN_Y_OFFSET = 60;
TimerMediator.ANIMATION_TIME = 500;